import React from 'react';
import styles from './styles.module.css';
import { Events } from '../../components/Icons';

const AdvisedFilter = () => {
  return (
    <div className={styles.main}>
      <div className={styles.leftSide}>
        <Events style={{ fontSize: '3.5rem', alignSelf: 'center',color:'var(--color-primary)' }} />
        <div className={styles.textArea}>
          <p className={styles.title}>Stay Flexible</p>
          <p className={styles.subText}>Book with Free Cancellation and get a full refund in case your plans change</p>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.button}>Filter By Free Cancellation</button>
      </div>
    </div>
  );
};
export default AdvisedFilter;
